(function () {
	function testimonialsSlider() {
		const sliders = document.querySelectorAll(".testimonials-slider");

		if (sliders.length) {
			sliders.forEach(slider => {
				const spaceBetween = document.querySelectorAll('.kawai-mood').length ? 50 : 30;
				const id = slider.dataset.sectionId,
					sliderInit = slider.dataset.sliderInit,
					centeredSlides = slider.dataset.centeredSlides === 'true' ? true : false,
					columnsDesktop = slider.dataset.columnsDesktop ? slider.dataset.columnsDesktop : 2;

				if (sliderInit == 'true') {
					const swiperfeaturedBlogSlider = new Swiper(`.testimonials-slider-${id}`, {
						loop: true,
						centeredSlides,
						slidesPerView: 1,
						spaceBetween: 30,
						slideToClickedSlide: true,
						navigation: {
							nextEl: `#shopify-section-${id} .slider-arrow-next`,
							prevEl: `#shopify-section-${id} .slider-arrow-prev`,
						},
						breakpoints: {
							750: {
								slidesPerView: 2
							},
							990: {
								spaceBetween,
								slidesPerView: columnsDesktop
							}
						}
					});
					
					// const btnPrev = document.querySelector(`#shopify-section-${id} .testimonials-wrap .slider-arrow-prev`);
					// const btnNext = document.querySelector(`#shopify-section-${id} .testimonials-wrap .slider-arrow-next`);

					// if (btnNext) {
					// 	btnNext.addEventListener('click', () => swiperfeaturedBlogSlider.slideNext());
					// }

					// if (btnPrev) {
					// 	btnPrev.addEventListener('click', () => swiperfeaturedBlogSlider.slidePrev());
					// }
					const testimonialsWrapper = document.querySelector(`#shopify-section-${id} .testimonials`) 

					testimonialsWrapper.addEventListener('click', (event) => {

						if (event.target.classList.contains('slider-arrow-next') || event.target.closest('.slider-arrow-next')) {
							swiperfeaturedBlogSlider.slideNext()
							updateSideBlockItem()
							
						} else if(event.target.classList.contains('slider-arrow-prev') || event.target.closest('.slider-arrow-prev')){
							swiperfeaturedBlogSlider.slidePrev()
							updateSideBlockItem()
						}
						
					})

				}
			})
		};

		function updateSideBlockItem () {

			const activeSlide = document.querySelector('.testimonials__slider-wrapper .swiper-slide-active')
			
			if(activeSlide){
				const activeCategory = activeSlide.getAttribute('data-testimonial-category');
				
				const sideBlockItems = document.querySelectorAll('.side-block-item');
				
				sideBlockItems.forEach(item => {
					const sideCategory = item.getAttribute('data-side-category');

					if (activeCategory == sideCategory){
						item.classList.add('side-active')
					} else {
						item.classList.remove('side-active')
					}
				})
			
			}
		}

		updateSideBlockItem()

	}
	


	document.addEventListener('DOMContentLoaded', testimonialsSlider);
	document.addEventListener('shopify:section:load', testimonialsSlider);
	window.addEventListener('resize', testimonialsSlider);
})();